import axios from 'axios';

export default {
  getDocuments(instances) {
    return axios.get(`/modules/documents/`, {
      headers: { instances: instances.join(',') },
    });
  },
};
